export default function separateParentsChildren(elements) {
  var topLevelElements = [];
  var childrenElements = [];

  if (!elements) {
    return [topLevelElements, childrenElements];
  }

  elements.forEach(el => {
    if (!(el.parent === 0)) {
      if (childrenElements[el.parent] !== null && typeof childrenElements[el.parent] == "object") {
        childrenElements[el.parent].push(el);
      } else {
        childrenElements[el.parent] = [el];
      }
    } else {
      topLevelElements.push(el);
    }
  });

  return [topLevelElements, childrenElements];
}